import React from "react";
// Inner Components
import CsvUploadAndErrorDetails from "./CsvUploadAndErrorDetails";
import NoContentImportCSV from "./NoContentImportCSV";
import { useSelector } from "react-redux";

// Constants
import { UPLOADING_STATUS } from "../../../../constants/GlobalConstants";

const CsvUploadingStatus = ({ isUploadingCSV }) => {
  const uploadedAndErrorFiles = useSelector(
    (state) => state.csvImportExportReducer?.uploadedAndErrorFiles
  );

  const uploadingFiles =
    uploadedAndErrorFiles?.filter((file) => file.status === UPLOADING_STATUS) ||
    [];

  return (
    <>
      {uploadingFiles.length > 0 ? (
        uploadingFiles.map((uploadDetails, index) => (
          <CsvUploadAndErrorDetails
            key={uploadDetails.csvUploadId ?? index}
            uploadDetails={uploadDetails}
            index={index}
            isUploadingCSV={isUploadingCSV}
          />
        ))
      ) : (
        <NoContentImportCSV />
      )}
    </>
  );
};

export default CsvUploadingStatus;
